import { api } from './api'

export interface Parametro {
  id_parametro: number
  tipo?: string
  chave: string
  valor: string
  descricao?: string
  config_path?: string
  created_at: string
  updated_at: string
}

export interface CreateParametroRequest {
  tipo?: string
  chave: string
  valor: string
  descricao?: string
  config_path?: string
}

export interface UpdateParametroRequest {
  tipo?: string
  chave?: string
  valor?: string
  descricao?: string
  config_path?: string
}

export interface SetParametroRequest {
  chave: string
  valor: string
  tipo?: string
  descricao?: string
  config_path?: string
}

export interface ApiResponse<T> {
  message: string
  success: boolean
  data: T
}

export interface PaginatedResponse<T> {
  message: string
  success: boolean
  data: {
    data: T[]
    meta: {
      total: number
      per_page: number
      current_page: number
      last_page: number
      first_page: number
      first_page_url: string
      last_page_url: string
      next_page_url?: string
      previous_page_url?: string
    }
  }
}

export const parametroService = {
  // Listar parâmetros com paginação
  async getParametros(params?: {
    page?: number
    limit?: number
    tipo?: string
    search?: string
    paginated?: boolean
  }): Promise<PaginatedResponse<Parametro> | ApiResponse<Parametro[]>> {
    const queryParams = new URLSearchParams()
    
    if (params?.page) queryParams.append('page', params.page.toString())
    if (params?.limit) queryParams.append('limit', params.limit.toString())
    if (params?.tipo) queryParams.append('tipo', params.tipo)
    if (params?.search) queryParams.append('search', params.search)
    if (params?.paginated !== undefined) queryParams.append('paginated', params.paginated.toString())

    const response = await api.get(`/parametros?${queryParams.toString()}`)
    return response.data
  },

  // Buscar parâmetro por ID
  async getParametroById(id: number): Promise<ApiResponse<Parametro>> {
    const response = await api.get(`/parametros/${id}`)
    return response.data
  },

  // Buscar valor por chave
  async getValorByChave(chave: string): Promise<ApiResponse<{ chave: string; valor: string }>> {
    const response = await api.get(`/parametros/valor/${chave}`)
    return response.data
  },

  // Criar parâmetro
  async createParametro(data: CreateParametroRequest): Promise<ApiResponse<Parametro>> {
    const response = await api.post('/parametros', data)
    return response.data
  },

  // Atualizar parâmetro
  async updateParametro(id: number, data: UpdateParametroRequest): Promise<ApiResponse<Parametro>> {
    const response = await api.put(`/parametros/${id}`, data)
    return response.data
  },

  // Deletar parâmetro
  async deleteParametro(id: number): Promise<ApiResponse<void>> {
    const response = await api.delete(`/parametros/${id}`)
    return response.data
  },

  // Configurar parâmetro (upsert)
  async setParametro(data: SetParametroRequest): Promise<ApiResponse<Parametro>> {
    const response = await api.post('/parametros/set', data)
    return response.data
  },

  // Listar tipos únicos
  async getTipos(): Promise<ApiResponse<string[]>> {
    const response = await api.get('/parametros/tipos')
    return response.data
  },

  // Contar parâmetros
  async countParametros(): Promise<ApiResponse<{ total: number }>> {
    const response = await api.get('/parametros/count')
    return response.data
  },

  // Inicializar parâmetros padrão
  async initDefaults(): Promise<ApiResponse<void>> {
    const response = await api.post('/parametros/init')
    return response.data
  }
}
